import { BOOKING_JOURNEY } from '../../lib/constants';

export const BookingJourney = () => {
  return (
    <section className="bg-[#0a0a0a] text-white py-24 md:py-32" data-testid="booking-journey-section">
      <div className="container-edge">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-16">
          <div className="md:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#eb5381]">How It Works</div>
            <h2 className="mt-3 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              The booking <span className="italic text-[#ed9393]">journey,</span> made effortless.
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-neutral-300 text-base md:text-lg max-w-md leading-relaxed">
              A seamless experience from discovery to confirmation — thoughtfully designed to help you find the perfect makeup artist without the stress.
            </p>
          </div>
        </div>

        <ol className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {BOOKING_JOURNEY.map((step) => (
            <li
              key={step.n}
              data-testid={`journey-step-${step.n}`}
              className="bg-[#0a0a0a] p-8 lg:p-10 min-h-[260px] flex flex-col justify-between hover:bg-[#1a1a1a] transition-colors"
            >
              <div className="font-serif text-5xl text-[#eb5381]">{step.n}</div>
              <div>
                <div className="font-serif text-2xl leading-tight">{step.t}</div>
                <p className="mt-3 text-sm text-neutral-400 leading-relaxed">{step.d}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
